import React, { useEffect, useState } from "react";
import Spinner from "../../../../../assets/images/spinner.gif";
import { useU2000BusyIndicatorContext } from "../../../context/busiIndicator/U2000BusyIndicatorContext";

const U2000BusyIndicator: React.FC = () => {
  const { isLoading } = useU2000BusyIndicatorContext();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    let timerBefore: ReturnType<typeof setTimeout> | null = null;

    if (isLoading) {
      timerBefore = setTimeout(() => {
        setVisible(true);
      }, 500);
    } else {
      setVisible(false);
    }

    return () => {
      if (timerBefore) clearTimeout(timerBefore);
    };
  }, [isLoading]);

  return (
    visible &&
    isLoading && (
      <div className="fixed top-0 left-0 flex h-full w-full items-center justify-center bg-[rgba(248,248,248,0.678)]">
        <img src={Spinner} className="h-16 w-16" alt="loading" />
      </div>
    )
  );
};

export default U2000BusyIndicator;
